import React from 'react';
import { observer } from 'mobx-react';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';
import DeviceInfoComponent from './Device-info.component';
import useDeviceInfo from './useDeviceInfo';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { values, handlers } = useDeviceInfo(onClose);

    return (
        <>
            <DeviceInfoComponent
                headers={values.headers}
                rows={values.rows}
                imei={values.imei}
                name={values.name}
                onDownloadClick={handlers.handleDownloadClick}
                onClose={onClose}
            />
        </>
    );
};

const DeviceInfoContainer = observer(Container);

export default DeviceInfoContainer;
